import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../contexts/AuthContext';
import greetingsData from '../../components/greetings.json';
import UserPool from '../../components/userPool';
import { 
  CognitoUser, 
  CognitoUserSession, 
  CognitoIdToken, 
  CognitoAccessToken, 
  CognitoRefreshToken 
} from 'amazon-cognito-identity-js';
import styles from './Login.module.css';
import LoaderWithDots from '../../components/loaderWithDots.js';
import { Player } from '@lottiefiles/react-lottie-player';
import backgroundAnimation from '../../assets/animations/spinner.json'; // adjust path as needed

const LoginCallback = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const getRandomGreeting = () => {
    const greetings = greetingsData.greetings;
    return greetings[Math.floor(Math.random() * greetings.length)];
  };

  useEffect(() => {
    const handleLogin = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");

      if (!code) {
        navigate("/login");
        return;
      }

      const API_URL = "https://pbkhrrgjtf.execute-api.us-east-1.amazonaws.com/prod/exchangeToken";
      const redirectUri =
      window.location.hostname === "localhost"
        ? "http://localhost:3000/login/callback"
        : "https://app.loggable.net/login/callback";

      try {
        // Exchange the code for tokens via Lambda
        const response = await fetch(API_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ 
            code,
            redirectUri
           }),
        });


        if (!response.ok) {
          const text = await response.text();
          navigate("/login");
          return;
        }

        const data = await response.json();

        const { id_token, access_token, refresh_token } = data;

        if (!id_token || !access_token) {
          console.error("[LoginCallback] Tokens missing from exchange response");
          navigate("/login");
          return;
        }

        // Decode JWT to get user info
        const payload = JSON.parse(atob(id_token.split(".")[1]));

        // Create a CognitoUserSession so getCurrentUser() works
        const cognitoUser = new CognitoUser({
          Username: payload.email,
          Pool: UserPool,
        });

        const session = new CognitoUserSession({
          IdToken: new CognitoIdToken({ IdToken: id_token }),
          AccessToken: new CognitoAccessToken({ AccessToken: access_token }),
          RefreshToken: refresh_token ? new CognitoRefreshToken({ RefreshToken: refresh_token }) : null,
        });

        cognitoUser.setSignInUserSession(session);

        // Update AuthContext
        login({ username: payload.email }, id_token);

        // Store user info in localStorage
        const userData = {
          email: payload.email,
          firstName: payload.given_name,
          lastName: payload.family_name,
          greeting: getRandomGreeting(),
        };
        localStorage.setItem("user", JSON.stringify(userData));

        navigate("/dashboard");
      } catch (error) {
        navigate("/login");
      }
    };

    handleLogin();
  }, []);

  return (
    <div className={styles.loginwrapper}>
      <div className={styles.logincard}>
        <div className={styles.loaderContainer}>
            <img
                src="/assets/loggableLogos/LoggableIconHorizontal.png"
                alt="Loggable Logo"
                className={styles.navLogo}
            />
          <h2 className={styles.center}>Signing in with Google...</h2>
          <p className={`${styles.center} ${styles.headerInfo}`}>
            Please wait while we securely log you in.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoginCallback;
